import {
  createdByUserUuid,
  snapSuggestionStatusSchema,
  stringToEnum,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import {
  priceStrategySchema,
  snapQuoteLineSourceSchema,
} from '@snap-types/models/enums';
import { decimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

export enum InitialMarginSource {
  lastWin = 'lastWin',
  targetContributionMargin = 'targetContributionMargin',
  targetGrossMargin = 'targetGrossMargin',
  calculatedFromLastWinUnitPrice = 'calculatedFromLastWinUnitPrice',
}

export const initialMarginSourceSchema = stringToEnum(InitialMarginSource);

export const columns = {
  uuid,
  lineNumber: z.number().int(),
  specs: z.string().nullish(),

  priceStrategy: priceStrategySchema,

  initialMarginSource: initialMarginSourceSchema.nullish(),
  lastWinOrderLineId: z.string().nullish(),

  leadTimeSuggestionStatus: snapSuggestionStatusSchema,
  suggestedPricesStatus: snapSuggestionStatusSchema,

  automatable: z.boolean(),

  leadTime: z.number().int().nullish(),
  leadTimeNotes: z.string().nullish(),
  automatedLeadTime: z.number().int().nullish(),
  userLeadTime: z.number().int().nullish(),

  configuratorSnapshotUuid: uuid.nullish(),

  customerPartId: z.string().nullish(),
  finishedPartId: z.string(),

  partUuid: uuid,
  snapQuoteVersionUuid: uuid,
  snapWorkOrderUuid: uuid.nullish(),

  priceAdjustment: decimal.nullish(),
  priceAdjustmentAmount: decimal.nullish(),

  productOptionsChangeUnitPrice: z.boolean(),

  snapQuoteLineSource: snapQuoteLineSourceSchema.nullish(),

  ...createdByUserUuid,
  ...timestamps,
};
